import type { PlannedMeal } from '../redux/mealPlanSlice';
import { isEntryMeal } from '../redux/mealEntry';
import { classifyDietKind } from './dietClassifier';

export type ProteinType = 'meat' | 'fish' | 'veggie' | 'unknown';

export function getProteinType(meal: PlannedMeal): ProteinType {
  // Entry and free-text meals are always unknown
  if (isEntryMeal(meal) || meal.recipeId === 'free-text') {
    return 'unknown';
  }

  // Priority 1: explicit dietaryRole on meal (set by the generator)
  if (meal.dietaryRole === 'fish') {
    return 'fish';
  }
  if (meal.dietaryRole === 'vegetarian') {
    return 'veggie';
  }

  // Priority 2: classify from diet tags, falling back to the title/ingredient
  // heuristic when tags are empty (the norm for scraped recipes).
  const recipe = meal.recipe;
  if (recipe) {
    const ingredients = (recipe.extendedIngredients ?? []).map((i) => i.name || i.original || '');
    const kind = classifyDietKind({ title: recipe.title ?? '', ingredients, diets: recipe.diets });
    return kind === 'veg' ? 'veggie' : kind === 'fish' ? 'fish' : 'meat';
  }

  // Priority 3: unknown for missing data
  return 'unknown';
}
